import * as React from 'react'
import * as rt from '../../config/routeType'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { styled, Tooltip, Collapse, Drawer as MuiDrawer } from '@mui/material'
import { Stack, Divider, IconButton, List, Box, Badge } from '@mui/material'
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Button } from '@mui/material'
import { show as showDrawerLeft } from '../../redux/slices/Drawer/drawerLeft'
import { show as showDrawerRight } from '../../redux/slices/Drawer/drawerRight'
import { changeMapStyle, changePopup } from '../../redux/slices/Map/map'
import { setOpen } from '../../redux/slices/Modal/modalBoxConfirmation'
import BoxConfirmation from '../../components/BoxConfirmation'
import BaseLayerList from '../RadioButtonGroup'
import PopoverSearch from '../PopoverSearch'
import ListMenu from './ListItem'
import _ from 'lodash'
//Icon
import { ReactComponent as MapBaseIcon } from '../../assets/icons/MapBase.svg'
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined'
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined'
import ArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import ArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined'
import logo_unl from '../../assets/images/logo_unl.png'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import DeckSharpIcon from '@mui/icons-material/DeckSharp'
import EditRoadSharpIcon from '@mui/icons-material/EditRoadSharp'
import DarkModeSharpIcon from '@mui/icons-material/DarkModeSharp'
import WbSunnySharpIcon from '@mui/icons-material/WbSunnySharp'
import SatelliteAltSharpIcon from '@mui/icons-material/SatelliteAltSharp'
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowY: 'visible',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(5)} + 1px)`,
  },
  [theme.breakpoints.up('xs')]: {
    width: `calc(${theme.spacing(5)} + 1px)`,
  },
})

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const widthIcon = { width: 20, height: 20 }

const textBasic = {
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontSize: '0.85em',
}

const TextLabel = styled('div')(() => ({
  ...textBasic,
  lineHeight: '1.25em',
}))

const stylePrimaryText = {
  ...textBasic,
  fontWeight: 700,
  lineHeight: '1em',
  color: '#6A6A6A',
}

const styleSecundaryText = {
  ...textBasic,
  fontSize: '0.8em',
  fontWeight: 500,
  lineHeight: '1.5em',
  color: 'var(--color-blue)',
}

const styleTextSecundaryMap = {
  ...textBasic,
  lineHeight: '1.25em',
  fontWeight: 400,
}
const icons = {
  satellite: SatelliteAltSharpIcon,
  light: WbSunnySharpIcon,
  dark: DarkModeSharpIcon,
  streets: EditRoadSharpIcon,
  outdoors: DeckSharpIcon,
}

const COLOR_FOR_HOVER = 'var(--color-blue-light)'

const DrawerLeftMenu = () => {
  const refBox = React.useRef(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  let location = useLocation()
  const { treeId } = useParams()

  const [openMapBase, setOpenMapBase] = React.useState(false)
  const [anchorMap, setAnchorMap] = React.useState(null)
  const [anchorFilter, setAnchorFilter] = React.useState(null)
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)

  const filterEnable = useSelector(state => state.filterSearch.enable)
  const { statusData, statusHeaders } = useSelector(state => state.report)
  const _stateDL = useSelector(state => state.drawerLeft)
  const _open = useSelector(state => state.drawerLeft.open)
  const _styleMaps = useSelector(state => state.mapState.style)
  const authenticated = useSelector(state => state.login.authenticated)
  const isAdmin = authenticated?.user?.rol?.includes('administrador')

  const open_popover_m = Boolean(anchorMap)
  const open_popover_f = Boolean(anchorFilter)
  const visible = _open ? 'block' : 'none'
  const id_pop_map = open_popover_m ? 'simple-popover-map' : undefined
  const id__pop_filter = open_popover_f ? 'simple-popover-filter' : undefined
  const mapKey = _.findKey(_styleMaps.type, o => o.id === _styleMaps.current)

  const widthMinDrawerLeft = !_open ? _stateDL.drawerWidthMin : _stateDL.drawerWidth

  const handleClosePopoverMap = () => setAnchorMap(null)
  const handleClosePopoverFilter = () => setAnchorFilter(null)
  const handleCollapseMapBase = event => {
    if (_open) setOpenMapBase(!openMapBase)
    else setAnchorMap(event.currentTarget)
  }
  const handleShowFilter = event => setAnchorFilter(event.currentTarget)

  const handleOpenCloseDrawerLeft = () => {
    dispatch(showDrawerLeft(!_open))
  }
  const handleClickGeoref = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    dispatch(changePopup(false))
    navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}/${rt.REGISTER_TREE}`, { replace: false })
  }
  const handleClickInformation = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    dispatch(changePopup(false))
    navigate(`/${rt.INFORMATION}`, { replace: false })
  }
  const handleChangeMap = idMap => {
    dispatch(changePopup(false))
    dispatch(changeMapStyle(idMap))
    if (location.pathname === `/${rt.MANAGEMENT_TREE}/${rt.TREE}/${treeId}`)
      navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: true })
    if (location.pathname === `${rt.MAIN}${rt.TREE}`) dispatch(showDrawerRight(false))
  }

  const handleClickManagement = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: false })
  }

  const handleGenerateReport = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    dispatch(setOpen(true))
  }

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: prop => true,
  })(({ theme, open }) => ({
    width: _stateDL.drawerWidth,
    height: '100vh',
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }))

  React.useEffect(() => {
    function handleWindowResize() {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  if (statusData === 'succeeded' && statusHeaders === 'succeeded') return null

  return (
    <Drawer
      variant={!_open ? 'permanent' : 'temporary'}
      open={_open}
      PaperProps={{ sx: { position: 'initial' } }}
      onClose={(event, reason) =>
        reason === 'backdropClick' && handleOpenCloseDrawerLeft()
      }>
      <DrawerHeader
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: _stateDL.drawerHeight,
        }}>
        <Stack display={visible}>
          <Box
            style={{
              height: `calc(${_stateDL.drawerHeight} - 0.5vh)`,
              paddingLeft: '0.375em',
            }}>
            <img src={logo_unl} alt="logo-unl" height="100%" />
          </Box>
        </Stack>
        <IconButton
          onClick={handleOpenCloseDrawerLeft}
          sx={{
            display: visible,
            fontSize: 0,
            p: '7px',
            '&:hover': {
              bgcolor: COLOR_FOR_HOVER,
            },
          }}>
          <ArrowLeftIcon sx={{ width: 20, height: 20 }} />
        </IconButton>
      </DrawerHeader>
      <Divider />

      <Box
        ref={refBox}
        sx={{
          width: widthMinDrawerLeft,
          color: 'var(--color-blue)',
          overflowY: 'auto',
        }}
        role="presentation">
        <List>
          <ListMenu simple={false}>
            <Tooltip title={!_open ? 'Filtrar Árboles' : ''} placement="left">
              <ListItemButton
                aria-describedby={id__pop_filter}
                variant="contained"
                onClick={handleShowFilter}
                sx={{
                  minHeight: '5vh',
                  pl: !_open ? '10px' : '14px',
                  '&:hover': {
                    color: 'var(--color-primary)',
                    bgcolor: COLOR_FOR_HOVER,
                  },
                }}>
                <ListItemIcon sx={{ minWidth: 0 }}>
                  <Badge color="secondary" variant="dot" invisible={!filterEnable}>
                    <TravelExploreOutlinedIcon
                      style={{ marginRight: _open ? '12px' : '0px', ...widthIcon }}
                    />
                  </Badge>
                </ListItemIcon>
                <ListItemText
                  primary="Filtrar Árboles"
                  primaryTypographyProps={stylePrimaryText}
                  sx={{ display: visible }}
                />
                {_open &&
                  (open_popover_f ? (
                    <KeyboardArrowLeftIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  ))}
              </ListItemButton>
            </Tooltip>
            <PopoverSearch
              id={id__pop_filter}
              open={open_popover_f}
              position={{ top: 55, left: parseInt(widthMinDrawerLeft, 10) + 5 }}
              anchorEl={anchorFilter}
              onClose={handleClosePopoverFilter}
            />
          </ListMenu>

          <ListMenu simple={false}>
            <Tooltip title={!_open ? 'Capa base' : ''} placement="left">
              <ListItemButton
                aria-describedby={id_pop_map}
                variant="contained"
                onClick={handleCollapseMapBase}
                sx={{
                  minHeight: '5vh',
                  pl: !_open ? '10px' : '14px',
                  '&:hover': {
                    color: 'var(--color-primary)',
                    bgcolor: COLOR_FOR_HOVER,
                  },
                }}>
                <ListItemIcon
                  sx={{ minWidth: 0, '&:hover': { color: 'var(--color-primary)' } }}>
                  <MapBaseIcon
                    style={{ marginRight: _open ? '12px' : '0px', ...widthIcon }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Capa base"
                  primaryTypographyProps={stylePrimaryText}
                  secondary={_styleMaps.type[`${mapKey}`].label}
                  secondaryTypographyProps={styleSecundaryText}
                  sx={{ display: visible }}
                />
                {_open && (openMapBase ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>
            </Tooltip>
            {_open ? (
              <Collapse in={openMapBase} timeout="auto" unmountOnExit>
                {Object.keys(_styleMaps.type).map(key => {
                  const _map = _styleMaps.type[`${key}`]
                  const IconMap = icons[`${key}`]

                  return (
                    <List key={key} component="div" disablePadding>
                      <ListItemButton
                        onClick={() => handleChangeMap(_map.id)}
                        sx={{ pl: 4, '&:hover': { bgcolor: COLOR_FOR_HOVER } }}>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <IconMap style={{ width: '20px' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={_map.label}
                          primaryTypographyProps={styleTextSecundaryMap}
                        />
                      </ListItemButton>
                    </List>
                  )
                })}
              </Collapse>
            ) : (
              <BaseLayerList
                id={id_pop_map}
                open={open_popover_m}
                anchorEl={anchorMap}
                onClose={handleClosePopoverMap}
              />
            )}
          </ListMenu>

          <ListMenu
            simple={true}
            keyText="adminRegister"
            onClick={handleClickManagement}
            primary="Administrar registros"
            iconType={<ForestOutlinedIcon sx={widthIcon} />}
          />

          <ListMenu
            simple={true}
            keyText="georef"
            onClick={handleClickGeoref}
            primary="Registrar árbol"
            iconType={<AddLocationAltOutlinedIcon sx={widthIcon} />}
          />

          {isAdmin && (
            <ListMenu
              simple={true}
              keyText="georef"
              onClick={handleGenerateReport}
              primary="Generar reporte"
              iconType={<SummarizeOutlinedIcon sx={widthIcon} />}
            />
          )}

          <ListMenu
            simple={true}
            keyText="georef"
            onClick={handleClickInformation}
            primary="Información"
            iconType={<InfoOutlinedIcon sx={widthIcon} />}
          />
        </List>

        <List>
          {!_open ? (
            <TextLabel sx={{ pl: '3px', fontWeight: 600 }}>Chan</TextLabel>
          ) : (
            <TextLabel sx={{ pl: '14px', fontWeight: 600 }}>Channels</TextLabel>
          )}
        </List>
        <Divider />
        <List>
          <Button
            target="_blank"
            variant="container"
            href="https://www.facebook.com/UNLoficial/"
            sx={{ width: '100%', px: 0, py: 0.5, minWidth: !_open ? 0 : 'auto' }}>
            <ListMenu
              simple={true}
              keyText="unlOficialFB"
              primary="@UNLoficial"
              iconType={<FacebookIcon sx={widthIcon} />}
            />
          </Button>
          <Button
            target="_blank"
            variant="container"
            href="https://twitter.com/unloficial"
            sx={{ width: '100%', px: 0, py: 0.5, minWidth: !_open ? 0 : 'auto' }}>
            <ListMenu
              simple={true}
              keyText="unlOficialTW"
              primary="@unloficial"
              iconType={<TwitterIcon sx={widthIcon} />}
            />
          </Button>
        </List>
      </Box>
      <Divider />
      <Box display="flex" flexGrow="1" width={widthMinDrawerLeft}>
        <List sx={{ height: '100%', width: '100%' }}>
          <ListMenu simple={false} keyText="bIconFooter" sx={{ height: '100%' }}>
            <Tooltip
              title={!_open ? 'Expandir' : ''}
              placement="left"
              sx={{ height: '100%' }}>
              <ListItemButton
                onClick={handleOpenCloseDrawerLeft}
                sx={{ px: !_open ? 0.5 : 2, height: '100%', py: 0 }}>
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: _open ? 1 : 'auto',
                    justifyContent: 'center',
                  }}>
                  <IconButton>
                    {!_open ? (
                      <ArrowRightIcon sx={widthIcon} />
                    ) : (
                      <ArrowLeftIcon sx={widthIcon} />
                    )}
                  </IconButton>
                </ListItemIcon>
                <ListItemText sx={{ display: visible }}>
                  <TextLabel sx={{ fontWeight: 400, lineHeight: '1em' }}>
                    Colapsar
                  </TextLabel>
                </ListItemText>
              </ListItemButton>
            </Tooltip>
          </ListMenu>
        </List>
      </Box>

      <BoxConfirmation
        title="Generar reportes tardará un momento ¿Desea esperar?"
        description="Cargar los registros de árboles en la tabla puede tardar unos segundos."
        width={windowWidth >= 700 ? 560 : `calc(${windowWidth}px - 10%)`}
        handleCancel={() => {
          dispatch(setOpen(false))
        }}
        handleContinue={() => {
          dispatch(setOpen(false))
          navigate(`/${rt.GENERATE_REPORT}`, { replace: false })
        }}
      />
    </Drawer>
  )
}
export default DrawerLeftMenu
